var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/access-logs/AccessLogs.vue?vue&type=template&id=1188f666
// module id = null
// module chunks = 